// Client-side CSV export of already-loaded (filtered) rows.
function escapeCell(val) {
    if (val === null || val === undefined) return '';
    const s = String(val);
    if (/[",\n]/.test(s)) return `"${s.replace(/"/g, '""')}"`;
    return s;
}

// columns: [{ header, accessor: (row) => value }]
export function exportToCsv(filename, rows, columns) {
    const header = columns.map((c) => escapeCell(c.header)).join(',');
    const lines = (rows || []).map((row) =>
        columns.map((c) => escapeCell(typeof c.accessor === 'function' ? c.accessor(row) : row[c.accessor])).join(',')
    );
    const csv = [header, ...lines].join('\n');
    const blob = new Blob(['\uFEFF' + csv], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    const stamp = new Date().toISOString().slice(0, 10);
    a.download = `${filename}-${stamp}.csv`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
}
